import { useState } from 'react';

const useConvertToBase64 = () => {
  const [error, setError] = useState(null);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        setError(null);
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        setError(error);
        reject(error);
      };
    });
  };

  return { error, convertToBase64 };
};

export default useConvertToBase64;
